// extracted by mini-css-extract-plugin
module.exports = {"heading":"NotFound_heading__3xG74"};